module.exports = __webpack_public_path__ + "static/media/favorite-bg.e4b769e6.png";